import {useTranslation} from "react-i18next";
import FormFieldBox from "../../common/form/FormFieldBox";
import TextInput from "../../common/form/TextInput";
import FormRow from "../../common/form/FormRow";
import React, {useMemo} from "react";
import {Control} from "react-hook-form";
import {useSelector} from "react-redux";
import {allowedUserNcosSelector} from "../../authentication/redux";
import {calculateAllowedNcos} from "../UserForm";

type Props = {
    index: number
    control: Control<any>
}


export const NcosForm = ({ index, control }: Props) => {
    const { t } = useTranslation()

    const allowedUserNcos = useSelector(allowedUserNcosSelector)

    const ncosOptions = useMemo(
        () =>
            calculateAllowedNcos("PREMIUM", allowedUserNcos)
                .map(ncos => ({ label: t(`users.ncos-names.${ncos}`), value: ncos })),
        [t, allowedUserNcos]
    )

    return (<FormRow>
        <FormFieldBox>
            <TextInput
                readonly={false}
                label={t('users.edit.ncos')}
                name={`fieldUpdates.${index}.values.0.stringValue`}
                control={control}
                required={true}
                options={ncosOptions}
            />
        </FormFieldBox>
    </FormRow>)
}